<template>
  <time :datetime="isoDateTime" :title="fullFormattedDateTime">{{ formattedDateTime }}</time>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { formatInstant, formatInstantCompact, formatInstantISO } from "@/helpers/date-utils";

export default Vue.extend({
  name: "LocalizedDateTime",
  props: {
    instant: Temporal.Instant as unknown as PropType<Temporal.Instant>,
    locale: String,
    timeZone: String,
  },
  computed: {
    isoDateTime(): string {
      if (!(this.instant instanceof Temporal.Instant)) return "";
      return formatInstantISO(this.instant);
    },
    formattedDateTime(): string {
      if (!(this.instant instanceof Temporal.Instant)) return "";
      return formatInstantCompact(this.instant, this.locale, this.timeZone);
    },
    fullFormattedDateTime(): string {
      if (!(this.instant instanceof Temporal.Instant)) return "";
      return formatInstant(this.instant, this.locale, this.timeZone);
    },
  },
});
</script>
